
export const adCategories = [
  { id: 'all', name: 'All Businesses', icon: 'ri-store-2-line' },
  { id: 'restaurant', name: 'Restaurants', icon: 'ri-restaurant-line' },
  { id: 'retail', name: 'Retail & Shopping', icon: 'ri-shopping-bag-line' },
  { id: 'health', name: 'Health & Wellness', icon: 'ri-heart-pulse-line' },
  { id: 'home', name: 'Home Services', icon: 'ri-home-gear-line' },
  { id: 'professional', name: 'Professional', icon: 'ri-briefcase-line' },
  { id: 'auto', name: 'Automotive', icon: 'ri-car-line' },
];

export const featuredAds = [
  {
    id: 1,
    name: 'Roseville Family Dental',
    tagline: 'Your smile is our passion',
    category: 'health',
    description:
      'Comprehensive family dentistry serving Roseville for over 20 years. From routine cleanings to cosmetic procedures, we provide gentle, personalized care for patients of all ages.',
    address: '1234 Douglas Blvd, Roseville, CA 95678',
    phone: '(916) 555-0142',
    website: 'https://rosevillefamilydental.com',
    image:
      'https://public.readdy.ai/ai/img_res/b0a2ff6c764777e210b8d2c2a9278104.jpg',
    logo: 'ri-tooth-line',
    rating: 4.9,
    reviews: 312,
    featured: true,
    offer: '20% Off First Visit',
  },
  {
    id: 2,
    name: 'Sierra Auto Works',
    tagline: 'Trusted auto repair since 2005',
    category: 'auto',
    description:
      'Full-service auto repair and maintenance shop specializing in both domestic and import vehicles. ASE-certified technicians, honest pricing, and a comfortable waiting area.',
    address: '890 Riverside Ave, Roseville, CA 95678',
    phone: '(916) 555-0198',
    website: 'https://sierraautoworks.com',
    image:
      'https://readdy.ai/api/search-image?query=modern%20auto%20repair%20shop%20exterior%20with%20clean%20professional%20look%20well%20organized%20garage%20bays%20with%20cars%20being%20serviced%20bright%20signage%20and%20tidy%20parking%20lot%20suburban%20California%20setting&width=600&height=400&seq=ad2&orientation=landscape',
    logo: 'ri-car-washing-line',
    rating: 4.8,
    reviews: 187,
    featured: true,
    offer: 'Free Brake Inspection',
  },
  {
    id: 3,
    name: 'Bloom & Vine Florist',
    tagline: 'Handcrafted arrangements for every occasion',
    category: 'retail',
    description:
      'A charming local florist offering stunning fresh flower arrangements, wedding florals, event decor, and weekly subscription bouquets sourced from Northern California farms.',
    address: '456 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0267',
    website: 'https://bloomandvine.com',
    image:
      'https://readdy.ai/api/search-image?query=beautiful%20flower%20shop%20interior%20with%20colorful%20fresh%20bouquets%20and%20arrangements%20on%20rustic%20wooden%20shelves%20warm%20lighting%20charming%20boutique%20florist%20with%20greenery%20and%20seasonal%20flowers%20cozy%20atmosphere&width=600&height=400&seq=ad3&orientation=landscape',
    logo: 'ri-plant-line',
    rating: 4.9,
    reviews: 156,
    featured: true,
    offer: '15% Off Wedding Packages',
  },
  {
    id: 4,
    name: 'Placer Fitness Studio',
    tagline: 'Transform your body, elevate your mind',
    category: 'health',
    description:
      'Boutique fitness studio offering yoga, pilates, HIIT, and spin classes. Small class sizes, expert instructors, and a supportive community atmosphere.',
    address: '2100 Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0334',
    website: 'https://placerfitness.com',
    image:
      'https://readdy.ai/api/search-image?query=modern%20boutique%20fitness%20studio%20interior%20with%20yoga%20mats%20and%20exercise%20equipment%20bright%20natural%20light%20through%20large%20windows%20clean%20minimalist%20gym%20design%20with%20wooden%20floors%20and%20mirrors&width=600&height=400&seq=ad4&orientation=landscape',
    logo: 'ri-run-line',
    rating: 4.7,
    reviews: 243,
    featured: false,
    offer: 'First Class Free',
  },
  {
    id: 5,
    name: 'Roseville Pizza Kitchen',
    tagline: 'Wood-fired perfection since 2012',
    category: 'restaurant',
    description:
      'Artisan wood-fired pizzas made with locally sourced ingredients, craft beers on tap, and a family-friendly patio. Known for our signature Roseville Supreme and garlic knots.',
    address: '780 Pleasant Grove Blvd, Roseville, CA 95678',
    phone: '(916) 555-0411',
    website: 'https://rosevillepizzakitchen.com',
    image:
      'https://readdy.ai/api/search-image?query=cozy%20artisan%20pizza%20restaurant%20interior%20with%20wood%20fired%20oven%20visible%20in%20background%20warm%20ambient%20lighting%20rustic%20Italian%20decor%20with%20exposed%20brick%20walls%20and%20wooden%20tables%20inviting%20dining%20atmosphere&width=600&height=400&seq=ad5&orientation=landscape',
    logo: 'ri-restaurant-2-line',
    rating: 4.6,
    reviews: 428,
    featured: false,
    offer: '',
  },
  {
    id: 6,
    name: 'Green Thumb Landscaping',
    tagline: 'Creating outdoor living spaces',
    category: 'home',
    description:
      'Full-service landscaping company offering design, installation, and maintenance. Specializing in drought-tolerant California native gardens, hardscaping, and outdoor kitchens.',
    address: '3200 Foothills Blvd, Roseville, CA 95747',
    phone: '(916) 555-0523',
    website: 'https://greenthumbroseville.com',
    image:
      'https://readdy.ai/api/search-image?query=beautiful%20landscaped%20front%20yard%20in%20California%20suburban%20home%20with%20drought%20tolerant%20native%20plants%20stone%20pathway%20green%20lawn%20and%20mature%20trees%20professional%20garden%20design%20sunny%20day&width=600&height=400&seq=ad6&orientation=landscape',
    logo: 'ri-leaf-line',
    rating: 4.8,
    reviews: 98,
    featured: false,
    offer: 'Free Design Consultation',
  },
  {
    id: 7,
    name: 'Summit Financial Advisors',
    tagline: 'Building wealth, securing futures',
    category: 'professional',
    description:
      'Independent financial planning firm helping Roseville families with retirement planning, investment management, tax strategies, and estate planning for over 15 years.',
    address: '1500 Eureka Rd Suite 200, Roseville, CA 95661',
    phone: '(916) 555-0678',
    website: 'https://summitfinancialroseville.com',
    image:
      'https://readdy.ai/api/search-image?query=modern%20professional%20financial%20office%20interior%20with%20elegant%20desk%20and%20comfortable%20client%20chairs%20bookshelf%20with%20financial%20books%20large%20windows%20with%20city%20view%20clean%20corporate%20design%20warm%20tones&width=600&height=400&seq=ad7&orientation=landscape',
    logo: 'ri-line-chart-line',
    rating: 4.9,
    reviews: 67,
    featured: false,
    offer: '',
  },
  {
    id: 8,
    name: 'Roseville Pet Paradise',
    tagline: 'Where pets are family',
    category: 'retail',
    description:
      'Premium pet supply store and grooming salon. We carry organic pet food, eco-friendly toys, and offer professional grooming, nail trimming, and puppy socialization classes.',
    address: '620 N Sunrise Ave, Roseville, CA 95661',
    phone: '(916) 555-0789',
    website: 'https://rosevillepetparadise.com',
    image:
      'https://readdy.ai/api/search-image?query=bright%20cheerful%20pet%20store%20interior%20with%20colorful%20pet%20supplies%20on%20shelves%20dog%20grooming%20area%20visible%20clean%20modern%20retail%20space%20with%20friendly%20atmosphere%20pet%20toys%20and%20accessories%20displayed%20neatly&width=600&height=400&seq=ad8&orientation=landscape',
    logo: 'ri-bear-smile-line',
    rating: 4.7,
    reviews: 201,
    featured: false,
    offer: '10% Off Grooming',
  },
  {
    id: 9,
    name: 'Craft & Cork Wine Bar',
    tagline: 'Sip, savor, socialize',
    category: 'restaurant',
    description:
      'Upscale wine bar featuring an extensive selection of California wines, artisan cheese boards, and small plates. Live music on weekends and private event space available.',
    address: '410 Vernon St, Roseville, CA 95678',
    phone: '(916) 555-0856',
    website: 'https://craftandcork.com',
    image:
      'https://readdy.ai/api/search-image?query=elegant%20wine%20bar%20interior%20with%20exposed%20brick%20walls%20wine%20bottles%20displayed%20on%20wooden%20racks%20ambient%20warm%20lighting%20comfortable%20bar%20seating%20sophisticated%20atmosphere%20with%20cheese%20board%20on%20counter&width=600&height=400&seq=ad9&orientation=landscape',
    logo: 'ri-goblet-line',
    rating: 4.8,
    reviews: 176,
    featured: false,
    offer: '',
  },
];

export const advertisingPlans = [
  {
    id: 'basic',
    name: 'Community Listing',
    price: 49,
    period: 'month',
    features: [
      'Business profile page',
      'Category listing',
      'Contact information display',
      'Google Maps integration',
      'Monthly analytics report',
    ],
    popular: false,
  },
  {
    id: 'featured',
    name: 'Featured Partner',
    price: 129,
    period: 'month',
    features: [
      'Everything in Community Listing',
      'Featured badge & priority placement',
      'Homepage carousel spotlight',
      'Special offer banner',
      'Social media promotion',
      'Weekly analytics report',
    ],
    popular: true,
  },
  {
    id: 'premium',
    name: 'Premium Sponsor',
    price: 249,
    period: 'month',
    features: [
      'Everything in Featured Partner',
      'Dedicated business page',
      'Blog feature article',
      'Email newsletter inclusion',
      'Event sponsorship opportunities',
      'Priority customer support',
      'Real-time analytics dashboard',
    ],
    popular: false,
  },
];
